export default "__VITE_ASSET__pyqANTBw__"